// components
import { Divider, Typography } from '@mui/material';
import SignalsTooltipLegend from './SignalsTooltipLegend';
import { Icon } from '@sdb/planning-ui';

// hooks
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

// styles
import { StyledBoxFlex } from 'components/shared/Box/Box.styles';
import {
  StyledKeyTooltipTypography,
  StyledTooltipContentStack
} from '../hooks/useGetColumns.styles';
import { StyledSignalsTooltipBox } from './DutyCell.styles';

// types
import type { DutySignals } from 'components/shared/ToolbarSet/components/DutyChip.types';

const TooltipContent = ({
  content,
  signals,
  isAbsentToday = false
}: {
  content: { label: string; value: string }[];
  signals?: DutySignals[];
  isAbsentToday?: boolean;
}) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'rosterPlan.dataGrid.tooltip'
  });

  const hasSignals =
    signals && Object.values(signals).some((value) => !!value.active);

  return (
    <StyledTooltipContentStack>
      {isAbsentToday && (
        <StyledSignalsTooltipBox isError>
          <Icon type="triangle-exclamation" />
          {t('absenceWarning')}
        </StyledSignalsTooltipBox>
      )}
      {content.map((item, index) => (
        <Fragment key={index}>
          <StyledBoxFlex>
            <StyledKeyTooltipTypography variant="body2">
              {item.label}
            </StyledKeyTooltipTypography>
            <Typography variant="body2">{item.value || '—'}</Typography>
          </StyledBoxFlex>
          {index === content.length - 1 ? null : <Divider />}
        </Fragment>
      ))}
      {hasSignals && <SignalsTooltipLegend signals={signals} />}
    </StyledTooltipContentStack>
  );
};

export default TooltipContent;
